module.exports = __webpack_public_path__ + "media/images/sandbox/card_opt-cccd79f56bfa03bc3d27ce10a5fdeaa1.png";